export const formatDate = {
  formatDateMonthFirst: 'MM/DD/YYYY',
  formatDateWithTime: 'MM/DD/YYYY h:mm A',
  formatDateMonthFull: 'D MMM, YYYY',
}
